import SrTextarea from "./SrTextarea.vue";

SrTextarea.install = function(Vue) {
  Vue.component(SrTextarea.name, SrTextarea);
};

export default SrTextarea;


// WEBPACK FOOTER //
// ./packages/SrTextarea/index.js